import { useQuery } from "@apollo/client/react";
import { Box } from "@nulogy/components";
import CheckboxSelect from "components/controls/CheckboxSelect";
import { GetAllLines } from "hooks/apollo/line/line.gql";
import React from "react";

export default function LinesSelector() {
  const { data, loading } = useQuery(GetAllLines, { variables: { activeOnly: false } });

  if (loading) return null;

  const lineOptions = data.lines.map((dataLine) => ({ label: dataLine.name, value: dataLine.id }));

  return (
    <Box data-testid="lines" pr="x2" pt="x1">
      <CheckboxSelect
        className="spec-lines-select"
        closeMenuOnSelect={false}
        field="lineIds"
        multiselect
        options={lineOptions}
        placeholder="Select lines..."
        width="stretch"
      />
    </Box>
  );
}
